import type { CampaignAnalyticsConfigData } from '@core/integrations-legacy';
import { createEntityCollectionStore } from '@core/ngrx-legacy';

const { actions, namespace, selectors, reducer } =
  createEntityCollectionStore<CampaignAnalyticsConfigData>()('CampaignAnalyticsData');

export {
  actions as CampaignAnalyticsDataActions,
  namespace as CampaignAnalyticsDataNamespace,
  reducer as CampaignAnalyticsDataReducer,
  selectors as CampaignAnalyticsDataSelectors,
};
